import { render, staticRenderFns } from "./WebhookForm.vue?vue&type=template&id=2a4977fb&"
import script from "./WebhookForm.vue?vue&type=script&lang=js&"
export * from "./WebhookForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports